/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";

import { jwtDecode } from "jwt-decode";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const [sessionExpired, setSessionExpired] = React.useState(false);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  // Check token expiration
  React.useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const currentTime = Date.now() / 1000;

          // Se o token expirou
          if (decoded.exp < currentTime) {
            setSessionExpired(true);
          } else {
            // Agenda verificação para quando expirar
            const timeUntilExpiry = (decoded.exp - currentTime) * 1000;
            // Limita o timeout a um valor razoável (ex: 24h) para não estourar integer do JS
            if (timeUntilExpiry > 0 && timeUntilExpiry < 2147483647) {
              const timer = setTimeout(() => {
                setSessionExpired(true);
              }, timeUntilExpiry);
              return () => clearTimeout(timer);
            }
          }
        } catch (error) {
          console.error("Invalid token:", error);
        }
      }
    };

    const timerCleanup = checkToken();
    return timerCleanup;
  }, []); // Run once on mount

  const handleLogout = () => {
    localStorage.removeItem("token");
    setSessionExpired(false);
    // Redireciona para login
    window.location.href = "/auth/login";
  };

  const getRoutes = (routes) => {
    return routes.flatMap((route, key) => {
      // Se for uma rota colapsada com sub-rotas (ex: Gerenciamento, Campanhas)
      if (route.collapse && route.views) {
        return route.views
          .filter((sub) => sub.layout === "/admin")
          .map((sub, i) => (
            <Route path={sub.path} element={sub.element} key={`${key}-${i}`} />
          ));
      }

      // Se for uma rota comum (não agrupada)
      if (route.layout === "/admin") {
        return (
          <Route path={route.path} element={route.element} key={key} />
        );
      }

      return null;
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/logo-mega-4.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/admin/index" replace />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>

      {/* Modal de Sessão Expirada */}
      <Modal isOpen={sessionExpired} centered backdrop="static" keyboard={false}>
        <ModalHeader className="bg-warning text-white">Sessão Expirada</ModalHeader>
        <ModalBody>
          Sua sessão expirou por segurança. Por favor, faça login novamente para continuar.
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleLogout}>
            Sair e Fazer Login
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Admin;
